module.exports = __webpack_public_path__ + "static/media/attention.39e8339c.svg";